import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import SeamlessImmutable from 'seamless-immutable';
import SettingsActionTypesEnum from './model/SettingsActionTypesEnum';
import { SettingsActionsType } from './settings.actions';
import i18next from 'i18next';
import { IParamConfigurationInDTO } from '../../repository/jago/model/input/IParamConfigurationInDTO';


export interface ISettingsInterface {
  language: string;
  isSpinnerVisible: boolean;
  whatsNew: {
    content: any[] | [];
    hasUpdate: false;
  };
  paramConfigs: {
    data: PaginatedDataDTO<IParamConfigurationInDTO>;
  };
  paramPublicConfigs: {
    data: IParamConfigurationInDTO[];
  };
  selectedParamConfig: IParamConfigurationInDTO | null;
}

const initialState = SeamlessImmutable<ISettingsInterface>({
  language: i18next.language,
  isSpinnerVisible: false,
  whatsNew: {
    content: [],
    hasUpdate: false,
  },
  paramConfigs: {
    data: {
      content: [],
      pagination: {
        number: 0,
        size: 0,
        totalPages: 0,
        totalElements: 0,
      },
    },
  },
  paramPublicConfigs: {
    data: [] as IParamConfigurationInDTO[],
  },
  selectedParamConfig: null,
});

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state: SeamlessImmutable.ImmutableObject<ISettingsInterface> = initialState, action: SettingsActionsType) {
  switch (action.type) {
    case SettingsActionTypesEnum.SET_LANGUAGE:
      return state.set('language', action.payload);
    case SettingsActionTypesEnum.SET_SPINNER_VISIBLE:
      return state.set('isSpinnerVisible', action.payload);
    case SettingsActionTypesEnum.SAVE_WHATSNEW_CONTENT:
      return state.setIn(['whatsNew', 'content'], action.payload);
    case SettingsActionTypesEnum.SAVE_WHATSNEW_HASUPDATE:
      return state.setIn(['whatsNew', 'hasUpdate'], action.payload);
    case SettingsActionTypesEnum.SAVE_PARAM_CONFIGS:
      return state.setIn(['paramConfigs', 'data'], action.payload);
    case SettingsActionTypesEnum.SET_SELECTED_PARAM_CONFIG:
      return state.set('selectedParamConfig', action.payload);
    case SettingsActionTypesEnum.SAVE_PARAM_PUBLIC_CONFIGURATION:
      return state.setIn(['paramPublicConfigs', 'data'], action.payload);
    default:
      return state;
  }
}
